import { useActionData, useNavigation } from 'react-router-dom';
import { UpdatePasswordAccount } from '../repo/AccountsRepo.js'
import PasswordUpdated from '../components/PasswordUpdated.jsx'
import FormUpdatePassword from '../components/FormUpdatePassword.jsx'

function AccountUpdatePasswordPage() {
  const responseData = useActionData()
  const updateNavigation = useNavigation()
  const isSubmitting = updateNavigation.state === 'submitting'

  return (
    <section>
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <p className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
          Alterar Senha
        </p>
        
        {(responseData && responseData.status === 200) ? <PasswordUpdated/> : <FormUpdatePassword isSubmitting={isSubmitting} responseData={responseData}/>}

      </div>
    </section>
  )
}

export default AccountUpdatePasswordPage

export async function action({request}) {
  const data = await request.formData()

  const passwords = {
    current_password: data.get('current_password'),
    new_password: data.get('new_password'),
    new_password_confirmation: data.get('new_password_confirmation')
  }

  return await UpdatePasswordAccount(passwords)
}
